import React, {useEffect, useState, useMemo, useRef} from "react";
import { AgGridReact } from "@ag-grid-community/react";
import "@ag-grid-community/styles/ag-grid.css";
import "@ag-grid-community/styles/ag-theme-quartz.css";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash, faEye,faPlus } from "@fortawesome/free-solid-svg-icons";
// import { Button, Modal } from "react-bootstrap";
// import Modal from "admin/common/Modal";
import { Button, Modal } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { apiUrl, assetsUrl } from "../../config/Config";
import moment from 'moment';
import Spinner from "react-activity/dist/Spinner";
import "react-activity/dist/Spinner.css";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import Swal from 'sweetalert2';
import Select from "react-select";
ModuleRegistry.registerModules([ClientSideRowModelModule]);

const HomepageStories = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const userdata = useSelector((store) => store.userReducer.userdata);
    const [showloding, setshowloding] = useState(false);
    const [showmodal, setshowmodal] = useState(false);
    const [editshowmodal, seteditshowmodal] = useState(false);
    const [selectedid, setselectedid] = useState(0);

    const [name, setname] = useState("");

    const [title, settitle] = useState("");
    const [datecheck, setdatecheck] = useState(false);

    const [allstories, setallstories] = useState([]);
    const [selectedstory, setselectedstory] = useState([]);


    const selectedidRef = useRef(0);
    selectedidRef.current = selectedid;



    const [rowData, setRowData] = useState([]);
  const [colDefs, setColDefs] = useState([]);
  const paginationPageSizeSelector = useMemo(() => {
    return [10, 20, 50, 100];
  }, []);

  const getBase64 = (file) => {
    return new Promise((resolve) => {
      let fileInfo;
      let baseURL = "";
      // Make new FileReader
      let reader = new FileReader();

      // Convert the file to base64 text
      reader.readAsDataURL(file);

      // on reader load somthing...
      reader.onload = () => {
        // Make a fileInfo Object
        // console.log("Called", reader);
        baseURL = reader.result;
        // console.log(baseURL);
        resolve(baseURL);
      };
      // console.log(fileInfo);
    });
  };

  const submithandle = async () => {
    if (Object.keys(selectedstory)?.length > 0) {
      setshowloding(true);
      var data = {
        storyid: selectedstory?.value
    };
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .post(apiUrl + "addtohomepagestory", data, headers)
        .then((res) => {
          // console.log('res >>>', res.data)
          if (res.data.status == "success") {
            window.location.reload();
          } else {
            if(res.data.message == "invalid user") {
              dispatch({ type: "userdata", payload: {} })
              navigate('/login');
            } else {
                Swal.fire({
                  title: '',
                  text: res.data.message,
                  icon: 'error',
                  customClass: {
                    icon: 'custom-swal-icon' // Apply the custom class
                  },
                  width: '350px',
                  confirmButtonText: 'Ok',
              confirmButtonColor: "rgb(59, 151, 196)",
                  customClass: {
                      popup: "small-icon-alert",
                    },
                });
            }
            setshowloding(false);
          }
        })
        .catch((err) => {
          setshowloding(false);
          alert(err.message);
        });
      setshowloding(false);
    } else {
      Swal.fire({
        title: '',
        text: "Empty Field",
        icon: 'error',
        customClass: {
          icon: 'custom-swal-icon' // Apply the custom class
        },
        width: '350px',
        confirmButtonText: 'Ok',
    confirmButtonColor: "rgb(59, 151, 196)",
        customClass: {
            popup: "small-icon-alert",
          },
      });
    }
  };

  const edithandle = async () => {
    
    console.log('selectedidRef.current >>', selectedidRef.current);
      if (title ) {
        setshowloding(true);
        var data = {
          id: selectedidRef.current,
          title: title,
          is_date_time: datecheck ? "true" : "false"
      };
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .post(apiUrl + "updatedisposition", data, headers)
          .then((res) => {
            // console.log('res >>>', res.data)
            if (res.data.status == "success") {
              seteditshowmodal(false);
              settitle("");
              setdatecheck(false);
              setselectedid(0);
              fetchallcourses();
              setshowloding(false);
            } else {
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/login');
              } else {
                Swal.fire({
                  title: '',
                  text: res.data.message,
                  icon: 'error',
                  customClass: {
                    icon: 'custom-swal-icon' // Apply the custom class
                  },
                  width: '350px',
                  confirmButtonText: 'Ok',
              confirmButtonColor: "rgb(59, 151, 196)",
                  customClass: {
                      popup: "small-icon-alert",
                    },
                });
              }
              setshowloding(false);
            }
          })
          .catch((err) => {
            setshowloding(false);
            alert(err.message);
          });
        setshowloding(false);
      } else {
        Swal.fire({
          title: '',
          text: "Empty Field",
          icon: 'error',
          customClass: {
            icon: 'custom-swal-icon' // Apply the custom class
          },
          width: '350px',
          confirmButtonText: 'Ok',
      confirmButtonColor: "rgb(59, 151, 196)",
          customClass: {
              popup: "small-icon-alert",
            },
        });
      }
    };

    const clickhandle = () =>  {
        // console.log('Mission Launched')
      }

      const editlocation = async(data) => {
        setselectedid(data?.id);
        console.log('editlocation data >>', data);
        settitle(data?.title);
        if(data?.is_date_time == "true") {
          setdatecheck(true);
        } else {
          setdatecheck(false);
        }
        
        
        // setname(data?.name);
        seteditshowmodal(true);
      }

      console.log('date check >>', datecheck)

      const deletecourse = async (id, title) => {
        console.log('id >>', id);
        const result = window.confirm('Are you sure you want to remove "'+title+'" from homepage' );
        if (result) {
          var data = JSON.stringify({
            id: id,
          });
          const headers = {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + userdata?.token,
            },
          };
          let resp = await axios
            .post(apiUrl + "deletehomepagestory", data, headers)
            .then((res) => {
              if (res.data.status == "success") {
                fetchallcourses();
              } else {
              }
            })
            .catch((err) => {
              alert(err.message);
            });
        } else {
          // User clicked Cancel or closed the dialog
          // console.log("User clicked Cancel");
        }
      };

      const defaultColDef = {
        flex: 1,
        // resizable: false,
      };


      const handleCheckboxChange = async(t, id, title) => {
        // console.log('t >>', t.target.checked);
        if(!t.target.checked) {
          const result = window.confirm('Are you sure you want to disable story "' + title + '"');
          if(result) {

          } else {
            return
          }
        }
        
    setshowloding(true);
    const headers = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + userdata?.token,
      },
    };
    var data = {
      'id': id,
      'status': t.target.checked ? 'true': 'false'
    }
    let resp = await axios
    .post(apiUrl + "updatestorystatus", data, headers)
    .then((res) => {
      if (res.data.status == "success") {
        fetchallcourses();
        setshowloding(false);
      } else {
        if(res.data.message == "invalid user") {
          dispatch({ type: "userdata", payload: {} })
          navigate('/login');
        } else {
          Swal.fire({
            title: '',
            text: res.data.message,
            icon: 'error',
            customClass: {
              icon: 'custom-swal-icon' // Apply the custom class
            },
            width: '350px',
            confirmButtonText: 'Ok',
        confirmButtonColor: "rgb(59, 151, 196)",
            customClass: {
                popup: "small-icon-alert",
              },
          });
        }
      }
    })
    .catch((err) => {
      alert(err.message);
    });
  setshowloding(false);
    console.log('data >>', data);
      }


    const fetchallcourses = async () => {
        setshowloding(true);
        const headers = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + userdata?.token,
          },
        };
        let resp = await axios
          .get(apiUrl + "admingetallhomepagestories", headers)
          .then((res) => {
            if (res.data.status == "success") {
              // console.log('getallcategories >>', res.data);
              var prevdata = res.data.data;
                if(res.data.allstories?.length > 0) {
                    var prevs = res.data.allstories;
                    var newarr = [];
                    for(var i = 0; i < prevs?.length; i++) {
                        var obj = {};
                        obj["label"] = prevs[i]?.title;
                        obj["value"] = prevs[i]?.id;
                        newarr.push(obj);
                    }
                    setallstories(newarr);
                } else {
                    setallstories([]);
                }   

              if(prevdata?.length > 0) {
                var columnsarr = [];
                var hidecolumns = ['id', 'created_at', 'updated_at', 'sort', 'image', 'status', 'categoryid', 'description', 'facebook', 'twitter', 'linkedin', 'instagram', 'pinterest', 'slug', 'points', 'type', 'is_date_time'];
                var columns = Object.keys(prevdata[0]);
                // console.log('columns  >>>', columns );
                for(var i = 0; i < columns?.length;i++) {
                  if(!hidecolumns.includes(columns[i])) {
                    var obj = {};
                    if(columns[i] !== 'title') {
                        obj.maxWidth = 150
                    } else {
                        // obj.maxWidth = 150
                    }
                    obj.field = columns[i];
                    // console.log('obj >>', obj)
                    columnsarr.push(obj);
                  }
                }
               

                //Image
                if(columns.includes('image')) {
                  var imageobj = 
              {
                field: "Image",
                headerName: "Image",
                cellRenderer: (props) => {
                  // console.log('image props >>', props);
                  return (
                    <>
                    {
                        props?.data?.image ? 
                        <Link
                    to={assetsUrl+'services/'+props?.data?.image}
                    target="_blank"
                    style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                  >
                    <FontAwesomeIcon
                      icon={faEye}
                      className="sidebaricons"
                      style={{ color: "blue" }}
                    />
                  </Link> : null
                    }
                    </>
                    
                  )
                },
                cellRendererParams: {
                  onClick: clickhandle,
                },
              }
              columnsarr.push(imageobj);
                }

                //created_at
            //     if(columns.includes('created_at')) {
            //       var craetddatobj = 
            //   {
            //     field: "Date",
            //     headerName: "Date",
            //     cellRenderer: (props) => {
            //       // console.log('date props >>', props);
            //       return (
            //              <div>
            //               <p className="created_at_value">{moment(props?.data?.created_at).format('DD MMMM YYYY HH:mm')}</p>
            //             </div>
            //       )
            //     },
            //     cellRendererParams: {
            //       onClick: clickhandle,
            //     },
            //   }
            //   columnsarr.push(craetddatobj);
            //     }

                 //status
            //  var statusobj = {
            //     field: "status",
            //     headerName: "Status",
            //     maxWidth: 150,
            //     cellRenderer: (props) => {
            //        // console.log('props >>', props?.data)
            //        return (
            //         <div className="d-flex">
            //           <div class="form-check">
            //             <input
            //             onChange={(t) => {handleCheckboxChange(t, props?.data?.id, props?.data?.title)}}
            //               type="checkbox"
            //               class="form-check-input tableformcheck"
            //               id="check1"
            //               name="option1"
            //               value="something"
            //               style={{marginTop: 12}}
            //               checked={props?.data?.status == 'true' || props?.data?.status == true ? true : false}
            //             />
            //           </div>
            //         </div>
            //       );
            //     },
            //   };
            //   columnsarr.push(statusobj);

            //   View
            // var viewobj = {
            //   field: "view",
            //   headerName: "View",
            //   maxWidth: 150,
            //   cellRenderer: (props) => {
            //     return (
            //     <Link
            //         to={'/story/'+props?.data?.slug}
            //         target="_blank"
            //         style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
            //       >
            //         <FontAwesomeIcon
            //           icon={faEye}
            //           className="sidebaricons"
            //           style={{ color: "blue" }}
            //         />
            //       </Link>
            //     );
            //   },
            //   cellRendererParams: {
            //     onClick: clickhandle,
            //   },
            // };
            // columnsarr.push(viewobj);
              
                //edit
            //   var editobj = 
            //   {
            //     field: "edit",
            //     headerName: "Edit",
            //     maxWidth: 150,
            //     cellRenderer: (props) => {
            //       return (
            //         <div
            //               onClick={() => {
            //                 editlocation(props?.data);
            //                 // console.log('props >>', props?.data);
            //               }}
            //               style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
            //             >
            //               <FontAwesomeIcon
            //                 icon={faPenToSquare}
            //                 className="sidebaricons"
            //                 style={{ color: "blue" }}
            //               />
            //             </div>
            //       )
            //     },
            //     cellRendererParams: {
            //       onClick: clickhandle,
            //     },
            //   }
            //   columnsarr.push(editobj);

                //delete
                var deleteobj = 
                {
                  field: "delete",
                  headerName: "Delete",
                  maxWidth: 150,
                  cellRenderer: (props) => {
                    
                    return (
                      <div
                            onClick={() => {
                              deletecourse(props?.data?.id, props?.data?.title);
                              // console.log('props >>', props?.data);
                            }}
                            style={{maxWidth: 35, paddingLeft: 10, paddingRight: 10, cursor: 'pointer'}}
                          >
                            <FontAwesomeIcon
                              icon={faTrash}
                              className="sidebaricons"
                              style={{ color: "red" }}
                            />
                          </div>
                    )
                  },
                  cellRendererParams: {
                    onClick: clickhandle,
                  },
                }
                columnsarr.push(deleteobj);

                setColDefs(columnsarr);
                setRowData(prevdata);
              } else {
                setColDefs([]);
                setRowData([]);
              }
              
              // setcoursesdata(res.data.data);
            } else {
              if(res.data.message == "invalid user") {
                dispatch({ type: "userdata", payload: {} })
                navigate('/login');
              } else {
                Swal.fire({
                  title: '',
                  text: res.data.message,
                  icon: 'error',
                  customClass: {
                    icon: 'custom-swal-icon' // Apply the custom class
                  },
                  width: '350px',
                  confirmButtonText: 'Ok',
              confirmButtonColor: "rgb(59, 151, 196)",
                  customClass: {
                      popup: "small-icon-alert",
                    },
                });
              }
            }
          })
          .catch((err) => {
            alert(err.message);
          });
          setshowloding(false);
    };

    useEffect(() => {
            if (userdata && Object.keys(userdata).length > 0) {
              //   fetchdata();
              fetchallcourses();
            } else {
              navigate("/login");
            }
          }, []);
    return (
      <div className="adminmainpagelayout">
        <div className="productstogglebar mt-2">
          <div
            className="filterdiv couponfilterdiv"
            onClick={() => {
              settitle("");
              setdatecheck(false);
              setshowmodal(true);
            }}
          >
            <FontAwesomeIcon
              icon={faPlus}
              className="iconstyles"
              style={{ color: "#64748B" }}
            />
            <p>Add New</p>
          </div>
        </div>

        <div
          className={"ag-theme-quartz"}
          style={{ width: "100%", height: 500, marginTop: 15 }}
        >
          <AgGridReact
            // modules={AllModules}
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            suppressRowClickSelection={true}
            groupSelectsChildren={true}
            rowSelection={"multiple"}
            pagination={true}
            paginationPageSize={10}
            paginationPageSizeSelector={paginationPageSizeSelector}
            // onGridReady={onGridReady}
          />
        </div>

        {/*Add modal */}
        <Modal
          show={showmodal}
          onHide={() => setshowmodal(false)}
          size="md"
          className="custom-width-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Add story to homepage</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="webadmin-modalmainbody">
              <div className="">
                <label className="addproduct-label">Select story</label>
                    <Select
                        closeMenuOnSelect={true}
                        value={selectedstory}
                        onChange={setselectedstory}
                        options={allstories}
                    />
              </div>
              

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    submithandle();
                  }}
                >
                  <p>Submit</p>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        {/*Edit modal */}
        <Modal
          show={editshowmodal}
          onHide={() => seteditshowmodal(false)}
          size="md"
          className="custom-width-modal"
        >
            <Modal.Header closeButton>
            <Modal.Title style={{ fontSize: 19 }}>Edit Disposition</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div className="webadmin-modalmainbody">
          <div className="">
                <label className="addproduct-label">Title</label>
                <input
                  value={title}
                  onChange={(t) => {
                    settitle(t.target.value);
                  }}
                  type="text"
                  className="form-control addproductinput"
                  placeholder="Enter Disposition Title"
                />
              </div>
              {/* <div className="d-flex mt-4">
                  <input 
                    checked={datecheck}
                    onChange={() => {setdatecheck(!datecheck)}}
                    type="checkbox"
                    className="dispocheckbox"
                  />
                  <label className="dispochecktext">Allow date & time</label>
              </div> */}
             
              

              <div className="col-md-12 mt-4">
                <div
                  className="formsubmitbtn"
                  onClick={() => {
                    edithandle();
                  }}
                >
                  <p>Update</p>
                </div>
              </div>
            </div>
          </Modal.Body>
          
        </Modal>
      </div>
    );
}

export default HomepageStories